import React, { useEffect, useRef, useState, useTransition } from "react";
import { useLocation } from "react-router-dom";
import CommonMuiTable, { Table } from "../../Component/Table/Table";
import { success, vector } from "../../assets/img";
import { Margin, usePDF } from "react-to-pdf";
import { get } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import DownloadPdf from "../../Component/DownloadPdf";
import moment from "moment";
import { Toast } from "../../Component/Toast";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { OptimizedTable } from "../../Component/Table/OptimizedTable";
import CustomScroll from "../../Component/CustomScroll";

const Sales = () => {
  const [isPending, startTransition] = useTransition();

  const location = useLocation();
  const listData = location.state?.listData;
  const slotId = location.state?.slotId;
  const ID = location.state?.ID;
  const reportName = location.state?.reportName;
  const lot_name = location.state?.lot_name;
  const time = location.state?.time;
  const date = location.state?.date;

  const [page, setPage] = useState(1);

  const [pagination, setPagination] = useState("");

  const [downSuccess, setDownSuccess] = useState(false);

  // console.log("listData", listData);
  const [loading, setLoading] = useState(false);

  const [list, setList] = useState(listData || []);

  const fetchList = async () => {
    // setLoader(true);
    const res = await get(`${URLS.SALESREPORT}/${reportName}?${ID}`);

    // console.log("Sales Report Response:", res);
    if (res?.status === "success") {
      startTransition(() => {
        setList(res);
      });
    }
    // setLoader(false);
  };

  useEffect(() => {
    const handleBeforeUnload = () => {
      sessionStorage.setItem("pageReloaded", "true");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    const wasReloaded = sessionStorage.getItem("pageReloaded");

    if (wasReloaded === "true") {
      fetchList();
      sessionStorage.removeItem("pageReloaded");
    }
  }, []);

  const columns = React.useMemo(
    () => [
      {
        Header: "Date",
        accessor: "date",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Time",
        accessor: "time",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Lot",
        accessor: "lot",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Details",
        accessor: "detail",
        Cell: ({ value }) => {
          const text = value || "";

          const lower = text.toLowerCase();
          let index = -1;

          if (lower.includes("dear")) {
            index = lower.indexOf("dear");
          } else if (lower.includes("kerala")) {
            index = lower.indexOf("kerala");
          }

          let firstLine = text;
          let secondLine = "";

          if (index !== -1) {
            firstLine = text.substring(0, index).trim();
            secondLine = text.substring(index).trim();
          }

          return (
            <div>
              <p>{firstLine}</p>
              {secondLine && <p>{secondLine}</p>}
            </div>
          );
        },
      },

      {
        Header: "Lot No",
        accessor: "my_number",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Qty",
        accessor: "qty",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Price Amount",
        accessor: "fees",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: () => (
          <div style={{ textAlign: "center" }}>
            Client <br /> ID
          </div>
        ),
        accessor: "client_id",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Result Status",
        accessor: "announce_status",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex ac-jc">
              <button
                // onClick={() => {
                //   handleStatus(row);
                // }}
                className={`${value === "Pending" ? "pending_icon" : "announcement_icon"
                  } border-0 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13`}
              >
                {value}
              </button>
            </div>
          );
        },
      },
    ],
    [],
  );

  const handleDownload = async () => {
    if (!list?.data?.length) {
      Toast("No data available to download");
      return;
    }

    try {
      setLoading(true);
      await generatePdf(list?.data);
      setDownSuccess(true);
    } catch (error) {
      console.error(error);
      Toast("Failed to download PDF");
    } finally {
      setLoading(false);
    }
  };

  const generatePdf = (rows) => {
    const doc = new jsPDF("p", "mm", "a4");

    const cleanedRows = rows.map((r) => {
      let detail = r?.detail;

      if (typeof detail === "string") {
        // Remove DEAR or KERALA and everything AFTER it
        detail = detail.replace(/\s*(dear|kerala).*$/i, "").trim();
      }

      return {
        ...r,
        detail,
      };
    });

    const finalRows = cleanedRows.length ? cleanedRows : rows;

    const pageWidth = doc.internal.pageSize.getWidth();

    // ---- HEADER ----
    doc.setFont("helvetica", "bold");
    doc.setFontSize(15);
    doc.text("Winner Agency – Sales Report", pageWidth / 2, 15, {
      align: "center",
    });

    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text(
      `Date: ${moment(date).format("DD-MM-YYYY") || 'All'}  |  Lot: ${lot_name || 'All'}  |  Time: ${time || 'All'}`,
      pageWidth / 2,
      22,
      { align: "center" },
    );

    doc.text(
      `Report Generated on: ${moment().format("DD-MM-YYYY hh:mm a")}`,
      pageWidth / 2,
      28,
      { align: "center" },
    );

    // ---- DIVIDER ----
    doc.setLineWidth(0.5);
    doc.line(10, 32, pageWidth - 10, 32);

    // ---- TABLE ----
    autoTable(doc, {
      startY: 36,
      head: [["Time", "Detail", "Lot No", "Qty", "Price", "User ID", "Status"]],
      body: finalRows.map((r) => [
        r.time || "-",
        r.detail || "-",
        r.my_number || "-",
        r.qty || "-",
        r.fees || "-",
        r.client_id || "-",
        r.announce_status || "-",
      ]),

      // 🔹 TOTAL ROW (FOOTER)
      foot: [
        [
          {
            content: "Total Price",
            colSpan: 4,
            styles: { halign: "right" },
          },
          {
            content: `Rs. ${list?.total_amount ?? 0}`,
            colSpan: 3,
            styles: { halign: "left" },
          },
        ],
      ],

      showFoot: "lastPage",

      styles: {
        fontStyle: "bold",
        textColor: "black",
        fontSize: 10,
        cellPadding: 1,
        overflow: "linebreak",
        lineWidth: 0.1,
        lineColor: [200, 200, 200],
      },

      headStyles: {
        fillColor: [0, 71, 67],
        textColor: 255,
        lineWidth: 0.5,
        valign: "middle",
        halign: "center",
        fontStyle: "bold",
        fontSize: 11,
      },

      footStyles: {
        fontSize: 12,
        fontStyle: "bold",
        halign: "left",
        fillColor: [246, 220, 181],
      },

      margin: 5,
    });

    doc.save(
      `winnersalesreport_${moment(date).format("DD-MM-YYYY")}_${time}.pdf`,
    );
  };


  const [browsHeader, setBrowsHeader] = useState(true);

  const maxHeight = useRef(window.visualViewport?.height || window.innerHeight);
  const isFirstRun = useRef(true);

  useEffect(() => {
    const handleResize = () => {
      const visibleHeight = window.visualViewport?.height || window.innerHeight;

      // 🔹 Skip logic on first run
      if (isFirstRun.current) {
        isFirstRun.current = false;
        setBrowsHeader(true);
        return;
      }

      // 🔻 Viewport reduced (keyboard / browser UI)
      if (visibleHeight < maxHeight.current) {
        setBrowsHeader(true);
      }
      // 🔺 Viewport restored
      else {
        maxHeight.current = visibleHeight;
        setBrowsHeader(false);

      }
    };

    window.visualViewport?.addEventListener("resize", handleResize);

    return () => {
      window.visualViewport?.removeEventListener("resize", handleResize);
    };
  }, [browsHeader]);

  return (

    <div style={{
      // marginBottom: browsHeader ? 42 : 42,
      // paddingBottom: browsHeader ? 45 : 45
    }} className="dashRightView marginScrolls no-overflow d-flex ac-jb flex-column">
      <CustomScroll height="100vh">
        <div className="container_overalls">

          <div
            style={{ marginRight: 22, marginBottom: 20 }}
            className="d-flex ac-je "
          >
            {loading ? (
              <span
                className="spinner-border spinner-border-sm"
                style={{ color: "#004743", width: 12, height: 12 }}
              />
            ) : downSuccess ? (
              <img src={success} height={20} />
            ) : (
              <img onClick={handleDownload} src={vector} height={15} />
            )}
          </div>
          <OptimizedTable
            columns={columns}
            setPageno={setPage}
            pagecount={pagination}
            data={list?.data}
            show={false}
          />

        </div>

      </CustomScroll>
      <div className="d-flex ac-jb px-3 team_size">
        <p className="f4 fs-xs-13 fs-sm-14 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20  white">
          Total Price
        </p>
        <p className="f4 fs-xs-13 fs-sm-10 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20 white ">
          {`₹ ${list?.total_amount || 0}`}
        </p>
      </div>
    </div>

  );
};

export default Sales;
